module.exports = __webpack_public_path__ + "static/Colossalis.8d724b1a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Colossalis.ttf
// module id = 278
// module chunks = 114276838955818